export default __webpack_public_path__ + "static/media/mode-7.667f5283.svg";